import PageDataContext from "@core-ui/ContextServices/PageDataContext";
import { useDiffStore } from "@core-ui/stores/DiffStore/DiffStore.provider";
import { useResourceDiffEnabled } from "@ext/git/core/Diff/components/store/DiffViewModeStore";
import { useMemo } from "react";

export const useIsDiffView = () => {
	const isReadOnly = PageDataContext?.value?.conf?.isReadOnly;
	const resourceDiffEnabled = useResourceDiffEnabled();
	const diffEnabled = useDiffStore((state) => !!state?.diff);

	return useMemo(
		() => resourceDiffEnabled || (diffEnabled && !isReadOnly),
		[resourceDiffEnabled, diffEnabled, isReadOnly],
	);
};
